import { render } from "./navigation-admin.vue?vue&type=template&id=4995ad06"
import script from "./navigation-admin.vue?vue&type=script&lang=js"
export * from "./navigation-admin.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/MBx/MBx/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__